import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import loadingState from 'modules/loadingState';
import userState from 'modules/userState';
import apiUserResp, { apiUserSaga } from 'modules/apiUserSaga';
import apiCommonResp, { apiCommonSaga } from 'modules/apiCommonSaga';
import apiSystemResp, { apiSystemSaga } from 'modules/apiSystemSaga';
import apiIntroResp, { apiIntroSaga } from 'modules/apiIntroSaga';
import apiServiceCntrResp, { apiServiceCntrSaga } from 'modules/apiServiceCntrSaga';
import apiServiceMngtResp, { apiServiceMngtSaga } from 'modules/apiServiceMngtSaga';
import apiSystemMngtResp, { apiSystemMngtSaga } from 'modules/apiSystemMngtSaga';
import apiDashboardResp, { apiDashboardSaga } from 'modules/apiDashboardSaga';
import apiDocumentResp, { apiDocumentSaga } from 'modules/apiDocumentSaga';
import apiStatisticsResp, { apiStatisticsSaga } from 'modules/apiStatisticsSaga';
import apiManuMngtResp, { apiManuMngtSaga } from 'modules/apiManuMngtSaga';
import navigationState from 'modules/navigationState';

const rootReducer = combineReducers({
  loadingState,
  userState,
  apiCommonResp,
  apiDashboardResp,
  apiDocumentResp,
  apiIntroResp,
  apiServiceCntrResp,
  apiServiceMngtResp,
  apiSystemMngtResp,
  apiSystemResp,
  apiUserResp,
  apiStatisticsResp,
  apiManuMngtResp,
  navigationState,
});

export function* rootSaga() {
  // all 함수는 여러 Saga를 합쳐 주는 역할을 한다.
  yield all([
    apiCommonSaga(),
    apiDashboardSaga(),
    apiDocumentSaga(),
    apiIntroSaga(),
    apiServiceCntrSaga(),
    apiServiceMngtSaga(),
    apiSystemMngtSaga(),
    apiSystemSaga(),
    apiUserSaga(),
    apiManuMngtSaga(),
    apiStatisticsSaga(),
  ]);
}

export default rootReducer;
